import React, { useState, useEffect } from "react";
import "../../../styles/Categories.css";
import Part5_DirectReading from "./Part5_DirectReading";
import { db } from "../../../firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { useAuth } from "../../../contexts/AuthContext";
import { freeContent } from "../../../utils/freeContent";
import { useSubscriptionStatus } from "../../../hooks/useSubscriptionStatus";

const PartsOfSpeechCategories = ({ onBack }) => {
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [completedCategories, setCompletedCategories] = useState({});
  const { currentUser } = useAuth();
  const { isActive } = useSubscriptionStatus();
  const [showVideoModal, setShowVideoModal] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const userDocRef = doc(db, "users", currentUser.uid);

    const unsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        const grammarData = data?.part5?.partsOfSpeech || {};
        const newCompletedCategories = {};

        Object.keys(grammarData).forEach((categoryId) => {
          if (grammarData[categoryId]?.completed) {
            newCompletedCategories[categoryId] = true;
          }
        });

        setCompletedCategories(newCompletedCategories);
      }
    });

    return () => unsubscribe();
  }, [currentUser]);

  const categories = [
    { id: 7, title: "시제 (Tense)", subcategory: "present-tense" },
    {
      id: 8,
      title: "가정법 및 도치 (Conditionals & Inversion)",
      subcategory: "conditionals",
    },
    {
      id: 9,
      title: "전치사, 접속부사",
      subcategory: "prepositions",
    },
    {
      id: 14,
      title: "접속사, 부사절 접속사",
      subcategory: "conjunctions",
    },
    {
      id: 15,
      title: "부정대명사, 지시대명사",
      subcategory: "noun-clauses",
    },
    {
      id: 10,
      title: "동명사, to부정사 (Gerund & Infinitive)",
      subcategory: "gerund",
    },
    {
      id: 11,
      title: "분사구문 (Participle Phrase)",
      subcategory: "participle",
    },
    {
      id: 12,
      title: "관계사, 관계부사, 분사 등 '수식하는 문장' 해석",
      subcategory: "relative",
    },
    {
      id: 16,
      title: "병렬구조 (Parallel Structure)",
      subcategory: "parallel-structure",
    },
    { id: 13, title: "문법구분없는 토익문장", subcategory: "general" },
  ];

  const handleCategorySelect = (id, subcategory) => {
    // 구독자인 경우 모든 컨텐츠에 접근 가능
    if (isActive) {
      setSelectedPattern(id);
      return;
    }

    // 비구독자인 경우 무료 컨텐츠 체크
    const freeSubcategories =
      freeContent.part5.subcategories["parts-of-speech"] || [];
    const isFreeContent = freeSubcategories.includes(subcategory);

    if (!isFreeContent) {
      // 구독자가 아니고 무료 콘텐츠도 아니면 접근 불가
      return;
    }

    setSelectedPattern(id);
  };

  if (selectedPattern) {
    return (
      <Part5_DirectReading
        patternId={selectedPattern}
        onBack={() => setSelectedPattern(null)}
      />
    );
  }

  return (
    <div className="categories-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <button className="back-button" onClick={onBack}>
          ← 뒤로가기
        </button>

        <button
          className="back-button"
          style={{ backgroundColor: "#4a4a7a" }}
          onClick={() => setShowVideoModal(true)}
        >
          설명 동영상 보기
        </button>
      </div>
      <h2>문장 훈련</h2>
      <div className="category-grid">
        {categories.map((category) => {
          const freeSubcategories =
            freeContent.part5.subcategories["parts-of-speech"] || [];
          const isFreeContent = freeSubcategories.includes(
            category.subcategory
          );

          return (
            <div
              key={category.id}
              className={`category-card ${
                completedCategories[category.id] ? "completed" : ""
              } ${!isActive && !isFreeContent ? "premium" : ""}`}
              onClick={() =>
                handleCategorySelect(category.id, category.subcategory)
              }
            >
              <div className="category-content">
                <h3>{category.title}</h3>
                {completedCategories[category.id] && (
                  <span className="completion-status">학습 완료!</span>
                )}
              </div>
              {!isActive && !isFreeContent && (
                <div className="lock-overlay">
                  <img src="/icons/lock.svg" alt="잠김" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {showVideoModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1100,
          }}
          onClick={() => setShowVideoModal(false)}
        >
          <div
            style={{
              background: "#222",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "800px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
              onClick={() => setShowVideoModal(false)}
            >
              ×
            </button>
            <video
              src="/videos/parts-of-speech-explanation.mp4"
              controls
              autoPlay
              style={{ width: "100%", marginTop: "20px" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PartsOfSpeechCategories;
